<template>
  <v-container v-if="item.title" class="py-10 py-md-13 py-lg-16 item">
    <div class="text-center item-title">
      <span class="font-montserrat">CONHEÇA O</span>
      <span class="ml-4 font-audacity">projeto</span>
    </div>

    <v-sheet class="mx-auto mt-3" color="transparent" max-width="600px">
      <div
        class="text-center font-montserrat item-subtitle"
        v-html="item.title"
      ></div>
    </v-sheet>

    <div
      v-if="item.text"
      class="text-center mt-6 font-montserrat item-text"
      v-html="item.text"
    ></div>

    <v-sheet
      v-if="item.video"
      @click="video = playVideo = true"
      class="pa-2 mt-10 mt-md-13 mt-lg-16 item-video"
      :class="{ playing: playVideo }"
      color="#EFEFEF"
    >
      <img
        v-if="!playVideo"
        class="d-block"
        :src="`https://img.youtube.com/vi/${getYoutubeCode(
          item.video
        )}/hqdefault.jpg`"
        width="100%"
      />

      <iframe
        v-if="playVideo"
        class="d-block"
        width="100%"
        height="100%"
        :src="`https://www.youtube.com/embed/${getYoutubeCode(
          item.video
        )}?autoplay=1&muted=1`"
        title="YouTube video player"
        frameborder="0"
        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
        allowfullscreen
      ></iframe>
    </v-sheet>
  </v-container>
</template>

<script>
import { getYoutubeCode } from "../../../utils/getYoutubeCode";

const _config = {
  mod: "aboutAngels",
};

export default {
  data: () => ({
    playVideo: false,
  }),
  created() {
    this.$rest(_config.mod).get({
      save: (state, data) => (state.item = data),
    });
  },
  computed: {
    item() {
      return this.$rest(_config.mod).item;
    },
  },
  methods: {
    getYoutubeCode,
  },
};
</script>

<style lang="scss" scoped>
.item {
  &-title {
    span {
      &:first-child {
        color: #58595b;
        font-size: 45px;
        font-weight: 700;

        @media screen and (max-width: 600px) {
          font-size: 28px;
        }
      }

      &:last-child {
        color: #76c043;
        font-size: 78px;
        @media screen and (max-width: 600px) {
          font-size: 48px;
        }
      }
    }
  }

  &-subtitle {
    color: #00567c;
    font-size: 28px;
    font-weight: 500;
    line-height: 34px;

    @media screen and (max-width: 600px) {
      font-size: 20px;
      line-height: 26px;
    }
  }

  &-text {
    color: #58595b;
    font-size: 18px;
    line-height: 27px;

    @media screen and (max-width: 600px) {
      font-size: 16px;
      line-height: 24px;
    }
  }

  &-video {
    border-radius: 32px !important;
    position: relative;

    &:not(.playing) {
      &:after {
        background-color: rgba(0, 0, 0, 0.4);
        background-image: url(/img/icons/play-video.png);
        background-position: center;
        background-repeat: no-repeat;
        border-radius: 32px !important;
        bottom: 8px;
        content: "";
        cursor: pointer;
        left: 8px;
        opacity: 0.8;
        position: absolute;
        right: 8px;
        top: 8px;
        transition: all 0.1s linear;
      }
    }

    img {
      aspect-ratio: 16 / 9;
      border-radius: 32px !important;
      object-fit: cover;
      -o-object-fit: cover;
    }

    iframe {
      aspect-ratio: 16 / 9;
      border-radius: 32px !important;
    }
  }
}
</style>
